/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react'
import { TooltipDescription } from './styles'
import { Tooltip } from '../../tooltip'

export interface TimelineTooltipProps {
  children: React.ReactNode
  description: string | string[]
  position?: 'left' | 'right' | 'top' | 'bottom'
}

export const TimelineTooltip = ({ position, children, description }: TimelineTooltipProps): JSX.Element => {
  if (!description || !children) return <></>

  const tooltipDescription = Array.isArray(description) ? description.map(passage => passage) : description

  return (
    <Tooltip
      description={<TooltipDescription>{tooltipDescription}</TooltipDescription>}
      position={position || 'bottom'}
      opacity={0.8}
      delay={0}
      textMaxWidth="400px"
    >
      {children}
    </Tooltip>
  )
}
